import setupAutocompletePorts from "@/components/elm_autocomplete"
import airbrakeClient, { logDecodingError } from "@/helpers/airbrake"
import { pushGa4Event } from "@/helpers/ga4_helper"
import Recaptcha from "@/helpers/recaptcha"

import { Elm } from "@/components/elm/EnquiryForm.elm"

const initEnquiryForm = async (): Promise<void> => {
  const node = document.getElementById("elm-enquiry-form")

  if (!node) return

  const flags = JSON.parse(node.dataset.elmFlags || "{}")
  const app = Elm.EnquiryForm.init({ node, flags })

  new Recaptcha("elm-enquiry-recaptcha", flags.recaptchaKey, app)

  setupAutocompletePorts({ app, data: flags.autocomplete })

  app.ports.flagDecodingError.subscribe(() => {
    logDecodingError(flags)
  })

  app.ports.pushGa4Event.subscribe(pushGa4Event)

  app.ports.reportError.subscribe((errors: Array<[string, Array<string>]>) => {
    void airbrakeClient.notify({
      error: "Failure submitting enquiry",
      params: Object.fromEntries(errors)
    })
  })
}

void initEnquiryForm()
